import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { SalesTeamCreateComponent } from './sales-team-create/sales-team-create.component';
import { SalesTeamDetailsComponent } from './sales-team-details/sales-team-details.component';
import { SalesTeamEditComponent } from './sales-team-edit/sales-team-edit.component';
import { SalesTeamReportingComponent } from './sales-team-reporting/sales-team-reporting.component';
import { SalesPersonProductionDashboardComponent } from '../dashboard/sales-person-dashboard/sales-person-production-dashboard/sales-person-production-dashboard/sales-person-production-dashboard.component';

const routes: Routes = [
  {
    path: 'Crm/SalesTeams',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesTeam,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: SalesTeamDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesTeam,
          breadcrumb: { label: ' ', alias: 'salesTeamDetails' },
        },
      },
      {
        path: 'Create',
        component: SalesTeamCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesTeam,
          breadcrumb: { label: ' ', alias: 'salesTeamCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: SalesTeamEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesTeam,
          breadcrumb: { label: ' ', alias: 'salesTeamEdit' },
        },
      },
      {
        path: 'Overview',
        component: SalesTeamReportingComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.SalesTeam,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesTeamRoutingModule {}
